// Vue
import { computed, onBeforeMount, toRef, watch } from 'vue'
import { debounce } from 'lodash'

const SUCCESS_TEXT = 'Verified'

export function useInput(props, currentValue, emit) {
	// Props
	const { autoSelectText, debounced, maxLength } = props

	// Refs
	const refValue = toRef(props, 'value')

	// Watch
	watch(refValue, newVal => {
		currentValue.value = newVal
	})

	// Computed
	const isInfoMessageSuccess = computed(
		() => props.infoMessage === SUCCESS_TEXT
	)

	// Hooks
	onBeforeMount(() => (currentValue.value = props.value))

	// Methods
	const handleFocus = e => {
		if (autoSelectText) {
			e.target.select()
		}
	}

	const onBlur = e => {
		if (!e.target.value) emit('change', currentValue.value)
	}

	const onChange = e => {
		if (maxLength) {
			currentValue.value = e.target.value.slice(0, maxLength)
		} else {
			currentValue.value = e.target.value
		}

		emit('change', currentValue.value)
	}

	const emitInput = isDeleted => {
		if (debounced) {
			debouncedSearch()
		} else {
			emit('input', currentValue.value, isDeleted)
		}
	}

	const onEnter = () => {
		emit('enter')
	}

	const handleInput = e => {
		if (maxLength) {
			currentValue.value = e.target.value.slice(0, maxLength)
		} else {
			currentValue.value = e.target.value
		}

		const isDeleted =
			e.inputType === 'deleteContentForward' ||
			e.inputType === 'deleteContentBackward'

		emitInput(isDeleted)
	}

	const debouncedSearch = debounce(async function() {
		emit('input', currentValue.value)
	}, 500)

	return {
		debounced,
		debouncedSearch,
		isInfoMessageSuccess,
		emitInput,
		handleFocus,
		onBlur,
		onChange,
		onEnter,
		handleInput
	}
}
